import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import deepdash from 'deepdash';
import * as lodash from 'lodash';

const _ = deepdash(lodash);

@Injectable()
export class APIInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const apiReq = req.clone({
            url: `${this.getApiServerUrl()}/${req.url}`,
            body: this.updateRequestBody(req.body),
        });
        return next.handle(apiReq);
    }

    getApiServerUrl() {
        return environment.apiUrl;
    }

    updateRequestBody(body: any): any {
        let result = body;
        if (!!body) {
            result = _.mapValuesDeep(body, (value: any) =>
                value === '' ? (value = null) : value
            );
        }
        return result;
    }
}
